import { IEditGameState } from './editGameContext';
import { EditGameActionTypes, TEditGameAction } from './editGameActions';

export const editGameReducer = (state: IEditGameState, action: TEditGameAction): IEditGameState => {
	switch (action.type) {
		case EditGameActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
				iconFileId: null,
				gameFileData: { fileId: '', fileHash: null, fileName: null },
			};
		case EditGameActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditGameActionTypes.SET_ALL_DATA:
			return {
				...state,
				gameID: action.payload.gameID,
				IDSelectedDeveloper: action.payload.IDSelectedDeveloper,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				applicationId: action.payload.applicationId,
				name: action.payload.name,
				versionCode: action.payload.versionCode,
				versionName: action.payload.versionName,
				description: action.payload.description,
				appStoreLink: action.payload.appStoreLink,
				playMarketLink: action.payload.playMarketLink,
				IDsSelectedLanguages: action.payload.IDsSelectedLanguages,
				translations: action.payload.translations,
				iconFilePath: action.payload.iconPath,
				gameFilePath: action.payload.gamePath,
			};
		case EditGameActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditGameActionTypes.SET_FILE:
			return {
				...state,
				iconFileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case EditGameActionTypes.DELETE_PHOTO:
			return {
				...state,
				iconFilePath: null,
				iconFileId: null,
				sourceUrlLocally: null,
			};
		case EditGameActionTypes.SET_FETCHED_DEVELOPERS:
			return {
				...state,
				fetchedDevelopers: action.payload.developers,
			};
		case EditGameActionTypes.SET_ID_DEVELOPER:
			return {
				...state,
				IDSelectedDeveloper: action.payload.IDDeveloper,
			};
		case EditGameActionTypes.REFETCH_DEVELOPERS:
			return {
				...state,
				needRefetchDevelopers: action.payload.needRefetch,
			};
		case EditGameActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.categories,
			};
		case EditGameActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDCategory,
			};
		case EditGameActionTypes.CHANGE_APPLICATION_ID:
			return {
				...state,
				applicationId: action.payload.applicationId,
			};
		case EditGameActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditGameActionTypes.CHANGE_VERSION_CODE:
			return {
				...state,
				versionCode: action.payload.versionCode,
			};
		case EditGameActionTypes.CHANGE_VERSION_NAME:
			return {
				...state,
				versionName: action.payload.versionName,
			};
		case EditGameActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditGameActionTypes.CHANGE_APP_STORE_LINK:
			return {
				...state,
				appStoreLink: action.payload.appStoreLink,
			};
		case EditGameActionTypes.CHANGE_PLAY_MARKET_LINK:
			return {
				...state,
				playMarketLink: action.payload.playMarketLink,
			};
		case EditGameActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				gameFileData: action.payload.fileData,
			};
		case EditGameActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case EditGameActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case EditGameActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case EditGameActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditGameActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditGameActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case EditGameActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditGameActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditGameActionTypes.RESET_FIELDS:
			return {
				...state,
				iconFileId: null,
				sourceUrlLocally: null,
				fetchedDevelopers: [],
				IDSelectedDeveloper: null,
				fetchedCategories: [],
				IDSelectedCategory: null,
				applicationId: '',
				name: '',
				versionCode: '',
				versionName: '',
				description: '',
				appStoreLink: '',
				playMarketLink: '',
				gameFileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				fetchedLanguages: [],
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
				translations: [],
			};
		default:
			return state;
	}
};
